import { render, staticRenderFns } from "./AlertDestinationDetailScreen.vue?vue&type=template&id=0c1d00be&scoped=true&lang=pug"
import script from "./AlertDestinationDetailScreen.vue?vue&type=script&lang=ts"
export * from "./AlertDestinationDetailScreen.vue?vue&type=script&lang=ts"
import style0 from "./AlertDestinationDetailScreen.vue?vue&type=style&index=0&id=0c1d00be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d00be",
  null
  
)

export default component.exports